import { cn } from "../lib/utils";
import React from "react";
import { Chip } from "./Chip";
import { DoubleIcon, Icon } from "./Icon";
const attachmentChipOverrides = cn("rounded-lg px-2 py-1 heading-sm gap-1.5", "bg-background text-foreground max-w-44", "align-middle");
/**
 * A compact, inline chip representing a file, document, or folder attached to a
 * conversation message, with a truncated label and a single `icon` or a `doubleIcon`
 * (main icon overlaid with a connector logo). Use it to reference attached documents
 * or connected resources within a chat message; for richer source references with
 * descriptions or images, use Citation instead.
 * @summary Inline attachment chip.
 */
export function AttachmentChip({
  icon,
  doubleIcon,
  className,
  label,
  size,
  color,
  isBusy,
  onRemove,
  onClick,
  ...linkProps
}) {
  const chipClassName = cn(attachmentChipOverrides, className);
  const iconElement = (icon || doubleIcon) && /*#__PURE__*/React.createElement("div", {
    className: "shrink-0"
  }, doubleIcon ? /*#__PURE__*/React.createElement(DoubleIcon, {
    ...doubleIcon
  }) : /*#__PURE__*/React.createElement(Icon, {
    ...icon
  }));
  if ("href" in linkProps && linkProps.href) {
    return /*#__PURE__*/React.createElement(Chip, {
      className: chipClassName,
      label: label,
      size: size,
      color: color,
      isBusy: isBusy,
      onRemove: onRemove,
      ...linkProps
    }, iconElement);
  }
  return /*#__PURE__*/React.createElement(Chip, {
    className: chipClassName,
    label: label,
    size: size,
    color: color,
    isBusy: isBusy,
    onRemove: onRemove,
    onClick: onClick
  }, iconElement);
}
//# sourceMappingURL=AttachmentChip.js.map